import { render } from "./standardDialog.vue?vue&type=template&id=bf87a304&scoped=true"
import script from "./standardDialog.vue?vue&type=script&lang=js"
export * from "./standardDialog.vue?vue&type=script&lang=js"

import "./standardDialog.vue?vue&type=style&index=0&id=bf87a304&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yimeng-admin\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf87a304"]])

export default __exports__